import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-huurtoeslag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-huurtoeslag.component.html',
  styleUrl: './tekst-huurtoeslag.component.scss',
})
export class TekstHuurtoeslagComponent {}
